import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "team",
  legacy: {
    data: "team",
    count: "count",
    fetch: "fetchTeams",
    create: "createOneTeam",
    update: "updateTeam",
    remove: "deleteTeam",
    updateState: "updateTeamState",
  },
});

export const TeamProvider = Provider;
export const useTeamContext = useValue;
